var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isStarted)?_c('v-app',{attrs:{"id":"auth"}},[_c('img',{staticClass:"logo_auth",attrs:{"src":_vm.logoSvg,"alt":"Logo"}}),_c('v-main',{staticClass:"d-flex justify-center align-center align-self-center"},[_c('div',{staticStyle:{"width":"360px"}},[_c('router-view')],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }